<template>
    <div :class="setBaseClass">

        <transition name="fade">

            <div>

                <b-modal :can-cancel="false" :trap-focus="true" :active.sync="isTocConsentModalActive" has-modal-card>
                    <toc-consent-modal v-if="isLoggedIn" v-on:accepted="tocAccepted" v-bind="formProps"></toc-consent-modal>
                </b-modal>

                <b-modal :active.sync="isOnboardingModalActive" has-modal-card>
                    <onboarding-modal v-if="isLoggedIn" v-on:start-tour="startTour" v-bind="formProps"></onboarding-modal>
                </b-modal>

                <b-modal :active.sync="isLoggedIn && $store.getters.isExpired && $store.state.view.name !== 'admin-order-detail' && $store.state.view.name !== 'admin-billing' && $store.state.view.name !== 'admin-plans' && $store.state.view.name !== 'admin-checkout'" has-modal-card :canCancel="false">
                    <account-expired-modal v-if="isLoggedIn && $store.getters.isExpired" v-on:close="gotoAdminPlans"></account-expired-modal>
                </b-modal>

                <nav v-if="isLoggedIn && $store.getters.userProfile.APP_ENV === 'production' && $store.getters.userProfile.APP_DEBUG" class="navbar navbar-danger">
                    <div class="container">
                        <div class="navbar-brand navbar-start">
                            <a class="navbar-item" href="#">
                                <b-icon icon="user-ninja" style="margin-right: 12px"></b-icon>
                                APP_DEBUG = TRUE (Please disable on production)
                            </a>
                        </div>
                    </div>
                </nav>

                <!-- mobile use warning -->
<!--                <nav v-if="! isMobile && isLoggedIn" class="navbar navbar-danger-dark" style="display: block !important">-->
<!--                    <div class="container">-->
<!--                        <div class="navbar-brand navbar-start">-->
<!--                            <a class="navbar-item" href="#">-->
<!--                                <b-icon icon="exclamation-triangle" style="margin-right: 12px"></b-icon>-->
<!--                                {{ $global.product_name }} is not fully functional on mobile devices. Use a desktop application to get the best experience possible.-->
<!--                            </a>-->
<!--                        </div>-->
<!--                    </div>-->
<!--                </nav>-->

                <nav v-if="isLoggedIn && $store.getters.impersonateUserId" class="navbar navbar-danger-dark">
                    <div class="container">
                        <div class="navbar-brand navbar-start">
                            <a class="navbar-item" href="#">
                                <b-icon icon="user-ninja" style="margin-right: 12px"></b-icon>
                                You are now impersonating user&nbsp;<strong>{{ $store.getters.userProfile.first_name }} ({{ $store.getters.userProfile.email }})</strong>&nbsp;of&nbsp;<strong>{{ $store.getters.userProfile.account.name }}</strong>

                                <span v-if="$store.getters.userProfile.account.state === 'PENDING_APPROVAL'">
                                    &nbsp;<i>(Account is in pending_approval mode)</i>
                                </span>
                                <span v-else-if="$store.getters.userProfile.account.state === 'INACTIVE'">
                                    &nbsp;<i>(Account is inactive)</i>
                                </span>
                                <span v-else-if="$store.getters.userProfile.account.state === 'DECLINED'">
                                    &nbsp;<i>(Account is declined)</i>
                                </span>
                            </a>

                        </div>
                        <div class="navbar-end">
                            <a class="navbar-item" @click="deImpersonateUser">
                                Exit
                            </a>
                        </div>
                    </div>
                </nav>

                <!-- last order not paid -->
                <nav v-if="isLoggedIn && $store.getters.userProfile.account.latest_order && $store.getters.userProfile.account.latest_order.status !== 'PAID'" class="navbar navbar-danger">
                    <div class="container">
                        <div class="navbar-brand navbar-start">
                            <a class="navbar-item" href="#">
                                <b-icon icon="exclamation-triangle" style="margin-right: 12px"></b-icon>
                                Our records show that the latest payment has not been received. 👉<router-link :to="{ name: 'admin-billing', query: { tab: 'order_history' } }" style="color: white !important"><b>Click here to go to the billing page</b></router-link>.
                            </a>
                        </div>
                    </div>
                </nav>

                <!-- last order not paid -->
<!--                <nav v-if="isLoggedIn && ! $store.getters.inTrial && accountConfig.sms_enabled && account.sms_credits_left <= 5" class="navbar navbar-danger is-hidden-mobile">-->
<!--                    <account-usage-bar v-model="$store.getters.userProfile.account"></account-usage-bar>-->
<!--                </nav>-->

                <nav v-if="isLoggedIn && account.plan === 'PAY AS YOU GO' && accountConfig.wa_enabled && account.wa_credits_left <= 10" class="navbar navbar-danger is-hidden-mobile">
                    <account-whatsapp-bar v-model="account"></account-whatsapp-bar>
                </nav>

                <!-- unresponsive channel -->
                <nav v-if="isLoggedIn && $store.getters.userProfile.account.latest_unresponsive_channel" class="navbar navbar-danger is-hidden-mobile">
                    <div class="container">
                        <div class="navbar-brand navbar-start">
                            <span class="navbar-item" href="#">
                               <b-icon pack="fab" icon="whatsapp" style="margin-right: 10px"></b-icon>
                                One of your channel is currently disconnected and cannot be used to send WhatsApp messages.&nbsp;<b><router-link :to="{ name: 'channels' }" style="color: white !important">More info</router-link></b>
                            </span>
                        </div>
                    </div>
                </nav>

                <template v-if="isLoggedIn && $store.getters.userProfile && $store.getters.userProfile.account.expires_at">
                    <account-expiration-bar v-model="$store.getters.userProfile.account.expires_at"></account-expiration-bar>
                </template>

                <nav v-show="isLoggedIn" class="navbar navbar-main is-transparent">
                    <div class="container">
                        <div class="navbar-brand">
                            <a class="navbar-item" href="/">
                                <!--<img src="/storage/images/logo_header.svg" width="112" height="28">-->
                                <template v-if="$global.product_name === 'Textpop'">
                                    <svg class="pname-header-logo" viewBox="0 0 100 88" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                                        <g id="Logo" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                                            <g id="LOGO" transform="translate(-1231.000000, -1217.000000)">
                                                <g id="Avatar-hollow" transform="translate(1231.000000, 1217.000000)">
                                                    <path d="M53.4444444,31 L92.8164062,15.5898438" id="Line" class="pname-header-logo-face" stroke-width="13" stroke-linecap="round"></path>
                                                    <path d="M53.4444444,81 L92.8164063,65.5898438" id="Line" class="pname-header-logo-face" stroke-width="13" stroke-linecap="round" transform="translate(73.130425, 73.294922) scale(1, -1) translate(-73.130425, -73.294922) "></path>
                                                    <path d="M53.4444444,48 L85.2222222,48" id="Line" class="pname-header-logo-face" stroke-width="13" stroke-linecap="round"></path>
                                                    <path d="M7.409375,21.4054687 L9.0265625,21.4054687 L9.0265625,12.5648437 C9.0265625,10.1929569 9.0894525,8.33320986 9.21523437,6.98554687 C9.34101625,5.63788389 9.69140337,4.4789111 10.2664062,3.50859375 C10.8414091,2.50233872 11.6679634,1.68476877 12.7460937,1.05585937 C13.8242241,0.42694998 15.0281184,0.1125 16.3578125,0.1125 C18.2265718,0.1125 19.9156175,0.813274242 21.425,2.21484375 C22.431255,3.14922342 23.0691393,4.29022764 23.3386719,5.63789062 C23.6082045,6.98555361 23.7429687,8.89920635 23.7429687,11.3789062 L23.7429687,21.4054687 L29.1335937,21.4054687 C31.2179792,21.4054687 32.8081976,21.8996044 33.9042969,22.8878906 C35.0003961,23.8761768 35.5484375,25.142961 35.5484375,26.6882812 C35.5484375,28.6648536 34.7668047,30.0484335 33.2035156,30.8390625 C31.6402266,31.6296915 29.4031396,32.025 26.4921875,32.025 L23.7429687,32.025 L23.7429687,59.0859375 C23.7429687,61.385949 23.8238273,63.1558532 23.9855469,64.3957031 C24.1472664,65.6355531 24.5785121,66.641793 25.2792969,67.4144531 C25.9800816,68.1871132 27.1210858,68.5734375 28.7023437,68.5734375 C29.5648481,68.5734375 30.7328051,68.4207047 32.20625,68.1152344 C33.6796949,67.8097641 34.8296834,67.6570312 35.65625,67.6570312 C36.8421934,67.6570312 37.9113234,68.1331984 38.8636719,69.0855469 C39.8160204,70.0378954 40.2921875,71.2148367 40.2921875,72.6164062 C40.2921875,74.9882931 38.9984504,76.8031187 36.4109375,78.0609375 C33.8234246,79.3187563 30.1039305,79.9476562 25.2523437,79.9476562 C20.6523207,79.9476562 17.1664181,79.1750077 14.7945312,77.6296875 C12.4226444,76.0843673 10.8683631,73.9461074 10.1316406,71.2148437 C9.39491819,68.4835801 9.0265625,64.8359603 9.0265625,60.271875 L9.0265625,32.025 L7.0859375,32.025 C4.9656144,32.025 3.34844307,31.52188 2.234375,30.515625 C1.12030693,29.50937 0.56328125,28.2336015 0.56328125,26.6882812 C0.56328125,25.142961 1.14725979,23.8761768 2.31523437,22.8878906 C3.48320896,21.8996044 5.18123886,21.4054687 7.409375,21.4054687 Z" id="t" class="pname-header-logo-face"></path>
                                                </g>
                                            </g>
                                        </g>
                                    </svg>
                                </template>
                                <template v-else>
                                    <svg xmlns="http://www.w3.org/2000/svg" class="pname-header-logo" viewBox="0 0 80 80">
                                        <path class="pname-header-logo-face" fill-rule="evenodd" d="M38.4173048,0.5 C59.6345964,0.5 76.8346096,17.7000132 76.8346096,38.9173048 C76.8346096,60.1345964 59.6345964,77.3346096 38.4173048,77.3346096 C17.2000132,77.3346096 0,60.1345964 0,38.9173048 C0,17.7000132 17.2000132,0.5 38.4173048,0.5 Z M38.4173048,4.91730481 C19.6396233,4.91730481 4.41730481,20.1396233 4.41730481,38.9173048 C4.41730481,57.6949863 19.6396233,72.9173048 38.4173048,72.9173048 C57.1949863,72.9173048 72.4173048,57.6949863 72.4173048,38.9173048 C72.4173048,20.1396233 57.1949863,4.91730481 38.4173048,4.91730481 Z M57.6216555,23.984375 C58.5404101,23.984375 59.3372771,24.3031218 60.0122805,24.940625 C60.6872839,25.5781282 61.0247805,26.3281207 61.0247805,27.190625 C61.0247805,27.9781289 60.7341584,29.168742 60.1529055,30.7625 L53.8810305,49.15625 C53.3372778,50.7125078 52.915407,51.8374965 52.6154055,52.53125 C52.315404,53.2250035 51.8419712,53.8437473 51.195093,54.3875 C50.5482148,54.9312527 49.6622861,55.203125 48.5372805,55.203125 C47.3747747,55.203125 46.4607213,54.9125029 45.795093,54.33125 C45.1294647,53.7499971 44.6372821,53.0375042 44.3185305,52.19375 C43.9997789,51.3499958 43.6529074,50.2531318 43.2779055,48.903125 L38.8904055,33.940625 L34.6435305,48.903125 C34.0810277,50.9843854 33.4716588,52.5546822 32.8154055,53.6140625 C32.1591522,54.6734428 31.0060388,55.203125 29.3560305,55.203125 C28.5122763,55.203125 27.795096,55.0390641 27.204468,54.7109375 C26.6138401,54.3828109 26.1216575,53.9140655 25.7279055,53.3046875 C25.3341535,52.6953095 24.987282,51.9734417 24.6872805,51.1390625 C24.387279,50.3046833 24.1529064,49.6437524 23.9841555,49.15625 L17.7685305,30.7625 C17.1497774,29.0374914 16.8404055,27.8468783 16.8404055,27.190625 C16.8404055,26.3656209 17.1685272,25.6250033 17.8247805,24.96875 C18.4810338,24.3124967 19.2872757,23.984375 20.2435305,23.984375 C21.5185369,23.984375 22.3810283,24.3453089 22.8310305,25.0671875 C23.2810328,25.7890661 23.759153,27.0218663 24.2654055,28.765625 L29.2716555,45.921875 L33.8279055,29.975 C34.3154079,28.3062417 34.6763418,27.1671905 34.910718,26.5578125 C35.1450942,25.9484345 35.5857148,25.3671903 36.232593,24.8140625 C36.8794712,24.2609347 37.7653999,23.984375 38.8904055,23.984375 C40.0341612,23.984375 40.9294648,24.2609347 41.576343,24.8140625 C42.2232212,25.3671903 42.6779042,25.9671843 42.9404055,26.6140625 C43.2029068,27.2609407 43.5685282,28.381242 44.0372805,29.975 L48.5935305,45.921875 L53.6560305,28.765625 C53.9935322,27.5281188 54.2654045,26.6328153 54.4716555,26.0796875 C54.6779065,25.5265597 55.0247781,25.0390646 55.5122805,24.6171875 C55.9997829,24.1953104 56.7029009,23.984375 57.6216555,23.984375 Z"/>
                                    </svg>
                                </template>
                            </a>


                            <b-dropdown aria-role="list" paddingless class="is-hidden-desktop" style="position:absolute; top: 9px; right: 4px;">
                                <button class="button is-white is-outlined" slot="trigger" style="border:0; padding:0; margin:0">
                                    <div class="navbar-burger burger" data-target="navbarExampleTransparentExample">
                                        <span></span>
                                        <span></span>
                                        <span></span>
                                    </div>
                                </button>
                                <b-dropdown-item aria-role="listitem"><router-link style="color:#000 !important" v-if="isLoggedIn && $store.getters.userProfile.role === 'SUPER'" class="navbar-item" :to="{ name: 'sa-accounts' }"><b-icon icon="user-tie" style="margin-right:6px"></b-icon>Accounts</router-link></b-dropdown-item>
                                <b-dropdown-item aria-role="listitem"><router-link style="color:#000 !important" v-if="isLoggedIn && $store.getters.userProfile && $store.getters.userProfile.role === 'SUPER'" class="navbar-item" :to="{ name: 'sa-system' }"><b-icon icon="server" style="margin-right:6px"></b-icon>System</router-link></b-dropdown-item>
                                <b-dropdown-item aria-role="listitem"><router-link style="color:#000 !important" class="navbar-item" to="/contactlists">Lists</router-link></b-dropdown-item>
                                <b-dropdown-item aria-role="listitem"><router-link style="color:#000 !important" class="navbar-item" to="/contacts">Contacts</router-link></b-dropdown-item>
                                <b-dropdown-item aria-role="listitem"><router-link style="color:#000 !important" class="navbar-item" to="/campaigns">Campaigns</router-link></b-dropdown-item>
                                <b-dropdown-item aria-role="listitem"><router-link style="color:#000 !important" class="navbar-item" to="/templates">Templates</router-link></b-dropdown-item>
                                <b-dropdown-item aria-role="listitem"><router-link style="color:#000 !important" class="navbar-item" to="/channels">Channels</router-link></b-dropdown-item>
                                <b-dropdown-item aria-role="listitem"><a href="#" class="navbar-item" style="color:#000 !important" @click="logout">Logout</a></b-dropdown-item>
                            </b-dropdown>

                        </div>

                        <div id="navbarExampleTransparentExample" v-show="isLoggedIn" class="navbar-menu">

                            <div id="v-step-0" class="navbar-start" v-show="! $store.getters.isExpired">
                                <router-link id="tour-dashboard-menu" class="navbar-item" to="/dashboard">Dashboard</router-link>
                                <router-link id="tour-contacts-menu" class="navbar-item" to="/contacts">Contacts</router-link>
                                <router-link id="tour-contactlists-menu" class="navbar-item" to="/contactlists">Lists</router-link>
                                <router-link id="tour-campaigns-menu" class="navbar-item" to="/campaigns">Campaigns</router-link>
                                <router-link id="tour-templates-menu" class="navbar-item" to="/templates">Templates</router-link>
                                <router-link id="tour-channels-menu" class="navbar-item" to="/channels">Channels</router-link>
                                <router-link v-if="isLoggedIn && $store.getters.userProfile.role === 'SUPER'" class="navbar-item" :to="{ name: 'sa-accounts' }"><b-icon icon="user-tie" style="margin-right:6px"></b-icon>Accounts</router-link>
                                <router-link v-if="isLoggedIn && $store.getters.userProfile && $store.getters.userProfile.role === 'SUPER'" class="navbar-item" :to="{ name: 'sa-system' }"><b-icon icon="server" style="margin-right:6px"></b-icon>System</router-link>
                            </div>

                            <div class="navbar-end">
                                <b-dropdown position="is-bottom-left" hoverable v-if="isLoggedIn">

                                    <a class="navbar-item navbar-link" slot="trigger">
                                        {{$store.getters.userProfile.first_name }} ({{ $store.getters.userProfile.account.name }})
                                    </a>

                                    <b-dropdown-item v-if="accountConfig.wa_enabled && (account.plan === 'PAY AS YOU GO' || account.plan === 'PLUS')" has-link style="padding:2px">

                                        <router-link :to="{name: 'admin-checkout', params: { tabIndex: 1, plan: 'PAY AS YOU GO' } }" exact>
                                            <small>Upgrade</small>
                                            <b-tooltip label="# WhatsApp credits left" position="is-left" type="is-dark">
                                                <b-tag type="is-success" size="is-small">
                                                    <b-icon pack="fab" size="is-small" icon="whatsapp" style="margin-left: 0px"></b-icon>&nbsp;
                                                    {{ account.wa_credits_left | currency('', 0, { thousandsSeparator: ',' }) }} {{ $options.filters.pluralize(account.wa_credits_left, 'credit') }} left
                                                </b-tag>
                                            </b-tooltip>
                                        </router-link>

<!--                                        </template>-->
                                    </b-dropdown-item>

                                    <b-dropdown-item v-if="accountConfig.sms_enabled"  has-link style="padding:2px">
                                        <router-link :to="{name: 'admin-checkout', params: { tabIndex: 1 } }" exact>
                                            <small>Upgrade</small>
                                            <b-tooltip label="Click to request SMS credit upgrade" position="is-left" type="is-dark">
                                                <b-tag type="is-light" size="is-small">
                                                    <b-icon size="is-small" icon="sms" style="margin-left: 0px"></b-icon>&nbsp;
                                                    {{ account.sms_credits_left | currency('', 0, { thousandsSeparator: ',' }) }} {{ $options.filters.pluralize(account.sms_credits_left, 'credit') }} left
                                                </b-tag>
                                            </b-tooltip>

                                        </router-link>

                                    </b-dropdown-item>

                                    <b-dropdown-item v-if="isLoggedIn && ($store.getters.userProfile.role === 'SUPER')" has-link>
                                        <router-link :to="{ name: 'admin-coupon-codes' }" exact>
                                            Coupon Codes
                                        </router-link>
                                    </b-dropdown-item>

                                    <b-dropdown-item v-if="account.plan === 'TRIAL'" has-link>
                                        <router-link :to="{ name: 'admin-plans' }" exact>
                                            <span class="error-color">
                                                <b>Upgrade plan</b>
                                            </span>
                                        </router-link>
                                    </b-dropdown-item>

                                    <hr class="dropdown-divider">

                                    <b-dropdown-item has-link>
                                        <router-link :to="{ name: 'account-settings' }" exact>
                                            Account & User Profile
                                        </router-link>
                                    </b-dropdown-item>

                                    <b-dropdown-item has-link>
                                        <router-link :to="{ name: 'event-log' }" exact>
                                            Api Log
                                        </router-link>
                                    </b-dropdown-item>

                                    <hr class="dropdown-divider">

                                    <b-dropdown-item has-link>
                                        <router-link :to="{name: 'generate-contact-widget'}" exact>
                                            Create contact widget script
                                        </router-link>
                                    </b-dropdown-item>

                                    <b-dropdown-item has-link>
                                        <router-link :to="{name: 'generate-subscribe-form'}" exact>
                                            Add subscribe form to site
                                        </router-link>
                                    </b-dropdown-item>

                                    <hr class="dropdown-divider">

                                    <b-dropdown-item has-link>
                                        <router-link :to="{ name: 'admin-billing' }" exact>
                                            Billing
                                        </router-link>
                                    </b-dropdown-item>

                                    <hr class="dropdown-divider">

                                    <b-dropdown-item v-if="isLoggedIn && ($store.getters.userProfile.role === 'SUPER' || $store.getters.impersonateUserId)" has-link>
                                        <router-link :to="{ name: 'sendSingleMessage' }" exact>
                                            Send single message
                                        </router-link>
                                    </b-dropdown-item>

                                    <b-dropdown-item value="logout" has-link>
                                        <a href="#" v-if="isLoggedIn" @click="logout">Logout</a>
                                    </b-dropdown-item>

                                </b-dropdown>
                            </div>

                        </div>
                    </div>
                </nav>

                <!-- Authenticated -->
                <div class="container main-container">
                    <router-view :key="$route.fullPath"></router-view>
                </div>

                <footer>
                </footer>
            </div>
        </transition>

        <v-tour name="myTour" :steps="steps" :callbacks="myCallbacks"></v-tour>
    </div>
</template>

<script>

    import TocConsentModal from '../helpers/tocConsentModal';
    import OnboardingModal from '../helpers/onboardingModal';
    import AccountExpiredModal from '../helpers/accountExpiredModal';
    import RequestUpgradeSMSLimitModal from '../helpers/requestUpgradeSMSLimitModal';

    import AccountExpirationBar from './common/account-expiration-bar.vue';
    import AccountUsageBar from './common/account-usage-bar.vue';
    import AccountWhatsappBar from './common/account-whatsapp-bar.vue';

    import { isMobile } from 'mobile-device-detect';

    export default {
        components: {
            isMobile, AccountExpirationBar, AccountUsageBar, AccountWhatsappBar, TocConsentModal, OnboardingModal, AccountExpiredModal
        },
        name: 'App',
        data: function() {
            return {
                steps: [
                    {
                        target: '#v-step-0',  // We're using document.querySelector() under the hood
                        content: `Welcome to the ${this.$global.product_name} Tour! Let's go through the basics.`,
                        params: {
                            placement: 'top'
                        }
                    },
                    {
                        target: '#tour-dashboard-menu',
                        content: 'This Dashboard shows you a quick overview of the current status of your campaigns and platform availability.',
                        params: {
                            placement: 'top'
                        }
                    },
                    {
                        target: '#tour-subscriptions',
                        content: `Subscribe to ${this.$global.product_name} Update to start receiving important updates through WhatsApp about your ${this.$global.product_name} account and like phone battery alerts.`,
                        params: {
                            placement: 'bottom'
                        }
                    },
                    {
                        target: '#tour-contactlists-menu',
                        content: 'NEW: Lists are used to send campaigns to. Each list contains a set of contacts that have subscribed or are uploaded for a certain topic or subject.',
                        params: {
                            placement: 'top'
                        }
                    },
                    {
                        target: '#tour-campaigns-menu',
                        content: 'Campaigns allows you to draft a multi media message and send it to a list. Schedule it for later or send it right away!',
                        params: {
                            placement: 'top'
                        }
                    },
                    {
                        target: '#tour-templates-menu',
                        content: 'To boost productivity create templates from messages that you use over and over again.',
                        params: {
                            placement: 'bottom'
                        }
                    },
                    {
                        target: '#tour-channels-menu',
                        content: `Channels are phone numbers connected to your ${this.$global.product_name} account to send messages from. By default a WhatsApp number is added for testing purposes.`,
                        params: {
                            placement: 'bottom'
                        }
                    },
                    {
                        target: '#tour-channels-request-channel',
                        content: 'To gain full access with unlimited subscribers connect one or more of your own Whatsapp accounts and phone numbers.',
                        params: {
                            placement: 'bottom'
                        }
                    },
                    {
                        target: '#tour-campaigns-create-button',
                        content: 'That’s it 👍 Now create your own campaign and feel the ease.',
                        params: {
                            placement: 'bottom'
                        }
                    }
                ],
                myCallbacks: {
                    onPreviousStep: this.myCustomPreviousStepCallback,
                    onNextStep: this.myCustomNextStepCallback
                },
                formProps: {
                  phone: null
                },
                show: false,
                isTocConsentModalActive: false,
                isOnboardingModalActive: false,
                isExpiredModalActive: false,
                user: null
            }
        },
        watch: {
            isLoggedIn: function (val) {
                // start tour debugging
                // check first time login, show onboarding modal
                if(this.$store.getters.enableAccountOnboarding && ! this.$store.getters.isExpired) {

                    // start tour with small delay
                    if(! this.isMobile) {
                        setTimeout(() => {
                            this.startTour();
                        },600);
                    }

                    this.formProps.phone = '+'+this.$store.getters.userProfile.account.contact_phone;
                    this.formProps.origin = this.$store.getters.userProfile.config.app_onboarding_phone_endpoint;
                    // this.formProps.channelId = this.$store.getters.userProfile.account.contact_phone;

                    setTimeout(() => {
                        this.isTocConsentModalActive = true;
                        // this.isOnboardingModalActive = true;
                    }, 500);

                } else if(this.$store.getters.isExpired &&
                    this.$store.state.view.name !== 'admin-plans' &&
                    this.$store.state.view.name !== 'admin-billing') {

                    setTimeout(() => {
                        this.isExpiredModalActive = true;
                    }, 1000);
                }
            }
        },
        computed: {
            account() {
                return this.$store.getters.userProfile.account;
            },
            accountConfig() {
                return this.$store.getters.userProfile.account.account_config;
            },
            isLoggedIn() {
                return this.$store.getters.userProfile ? true : false;
            },
            isUnauthenticated() {
                return this.$route.name === 'login' || this.$route.name === 'forgot-password';
            },
            setBaseClass() {
                if(this.$store.state.view) {
                    return 'view-'+this.$store.state.view.name;
                } else {
                    return 'view-not-specified';
                }
            }
        },
        methods: {
            myCustomPreviousStepCallback (currentStep) {
            },
            myCustomNextStepCallback (currentStep) {

                const nextStep = currentStep + 1;
                switch(nextStep) {
                    case 1:
                    case 2:
                        this.$router.push({ name: 'dashboard' });
                        break;
                    case 3:
                        this.$router.push({ name: 'contactlists' });
                        break;
                    case 4:
                        this.$router.push({ name: 'campaigns' });
                        break;
                    case 5:
                        this.$router.push({ name: 'templates' });
                        break;
                    case 6:
                    case 7:
                        this.$router.push({ name: 'channels' });
                        break;
                    case 8:
                        this.$router.push({ name: 'campaigns' });
                        break;
                }
            },
            tocAccepted() {
                setTimeout(() => { this.isOnboardingModalActive = true}, 300);
            },
            deImpersonateUser() {

                this.$store.dispatch('deImpersonateUser', {}).then((data) => {
                    this.$buefy.toast.open({
                        message: 'Exiting Impersonation...',
                        type: 'is-warning',
                        duration: 1000
                    });

                    this.$router.push({name: 'sa-accounts' });

                }).catch((error) => { });
            },
            logout() {

                this.$store.dispatch('logout');
                this.$router.push({ name: 'login' });
            },
            startTour: function () {
                this.$tours['myTour'].start();
            },
            gotoAdminPlans() {
                this.$router.push({ name: 'admin-plans' });
            }
        },
        mounted() {
            this.show = true;
        }
    }
</script>
